module.exports = __webpack_public_path__ + "/build/web/images/hero-stalenservice@2x.00a0c256372ee872acd338eac1dd8df8.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-stalenservice@2x.jpg
// module id = 146
// module chunks = 13